var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.slotKeys, function (key) {
      return _c("JumpTem", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentSlotKey === key,
            expression: "currentSlotKey === key",
          },
        ],
        key: key,
        ref: key + "_JumpTem",
        refInFor: true,
        attrs: {
          value: _vm.dataMap[key],
          mark: key,
          isDefaultBanner: _vm.isDefaultBanner,
        },
        on: {
          change: function (newVal) {
            return _vm.$set(_vm.dataMap, key, newVal)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "banner",
              fn: function () {
                return [
                  _c(
                    "el-form",
                    {
                      ref: key + "_bannerForm",
                      refInFor: true,
                      attrs: {
                        model: _vm.dataMap[key],
                        rules: _vm.rules,
                        "label-width": "120px",
                        size: "small",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "banner 位置", prop: "slotKey" } },
                        [
                          !_vm.isEdit
                            ? _c(
                                "div",
                                [
                                  _vm.useTabStyle
                                    ? _c(
                                        "div",
                                        { staticClass: "banner-tabs" },
                                        [
                                          _c(
                                            "el-tabs",
                                            {
                                              on: {
                                                "tab-click": _vm.slotKeyChange,
                                              },
                                              model: {
                                                value: _vm.activeTab,
                                                callback: function ($$v) {
                                                  _vm.activeTab = $$v
                                                },
                                                expression: "activeTab",
                                              },
                                            },
                                            _vm._l(
                                              _vm.slotKeys,
                                              function (item) {
                                                return _c("el-tab-pane", {
                                                  key: item,
                                                  attrs: {
                                                    label:
                                                      _vm.positionTitle(item),
                                                    name: item,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "el-radio-group",
                                        {
                                          on: { change: _vm.slotKeyChange },
                                          model: {
                                            value: _vm.currentSlotKey,
                                            callback: function ($$v) {
                                              _vm.currentSlotKey = $$v
                                            },
                                            expression: "currentSlotKey",
                                          },
                                        },
                                        _vm._l(_vm.slotKeys, function (item) {
                                          return _c(
                                            "el-radio",
                                            {
                                              key: item,
                                              attrs: { label: item },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.positionTitle(item))
                                              ),
                                            ]
                                          )
                                        }),
                                        1
                                      ),
                                ],
                                1
                              )
                            : _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.positionTitle(_vm.dataMap[key].slotKey)
                                  )
                                ),
                              ]),
                        ]
                      ),
                      _vm.isDefaultBanner
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "名称", prop: "name" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  placeholder: "请输入广告名称",
                                  maxlength: "30",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.dataMap[key].name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.dataMap[key], "name", $$v)
                                  },
                                  expression: "dataMap[key].name",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        { attrs: { label: "banner图", prop: "imgUrl" } },
                        [
                          _c("imageUpload", {
                            attrs: {
                              imageList: _vm.dataMap[key].imgUrl
                                ? [{ url: _vm.dataMap[key].imgUrl }]
                                : [],
                              limit: 1,
                              fileSize: 1,
                              isShowTip: true,
                              WHtip: true,
                              width: _vm.width,
                              height: _vm.height,
                              fileType: ["png", "jpg"],
                              accept: ".jpg,.png",
                              multiple: false,
                              code: "banner",
                            },
                            on: {
                              input: function (val) {
                                return _vm.getImg(val, "imgUrl", key)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }